import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import ArenaOfferCard from '@/components/OffersMarket/ArenaOffers/ArenaOfferCard';
import { H2, TextSmall } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';
import { useAppSelector } from '@/redux/store';

const OffersForLeague: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userLevel = useAppSelector((state) => state.user.user?.level);
  const arenaOffers = useAppSelector((state) =>
    [...state.shop.arenaOffers].sort(
      (a, b) => a.cost.base.usd - b.cost.base.usd,
    ),
  );

  const userLevelLessThan7 = (userLevel || 0) < 7;

  return (
    <div className="flex flex-col items-center w-full flex-1">
      <div className="w-full flex items-center gap-4 mb-2 px-3">
        <span className="flex-1 h-[1px] bg-white/40"></span>
        <H2 weight="bold">
          {t(userLevelLessThan7 ? 'Get ready for battle' : 'Prime time offers')}
        </H2>
        <span className="flex-1 h-[1px] bg-white/40"></span>
      </div>
      <TextSmall className="!leading-1.3 !text-white/60 max-w-[21rem] text-center mb-6">
        {t(
          userLevelLessThan7
            ? 'A new competition is about to begin, you still have time to gather resources, boost your production and enter the Arena fully prepared!'
            : 'Grow your industry and secure your lead!',
        )}
      </TextSmall>

      {!userLevelLessThan7 && (
        <div className="w-full flex flex-col gap-5">
          {arenaOffers.map((el) => {
            return <ArenaOfferCard {...el} />;
          })}
        </div>
      )}

      {userLevelLessThan7 && (
        <MainButton
          onClick={() => navigate(AppRoute.SHOP)}
          text={t('Go to shop')}
          className="mt-auto"
        />
      )}
    </div>
  );
};

export { OffersForLeague };
